export default "__VITE_ASSET__Dia399p5__"